import axios from "axios";
import { PATIENT_DEACTIVATION, UNSUBSCRIBE_REASONS } from "../conf/appSetting";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

// Flujo de baja automática de paciente (endpoints @PermitAll, sin token):
// 1) request -> valida que el paciente exista y esté activo
// 2) send-code -> envía el código de confirmación por WhatsApp/email
// 3) process -> valida el código y ejecuta la baja
export const DeactivateRequest = async (dni) => {
  const { data } = await axios.get(`${PATIENT_DEACTIVATION.base}/request/${dni}`, {
    headers,
  });
  return data;
};

export const DeactivateSendCode = async (dni) => {
  const { data } = await axios.get(
    `${PATIENT_DEACTIVATION.base}/send-code/${dni}`,
    { headers }
  );
  return data;
};

export const DeactivateProcess = async (dni, body) => {
  const { data } = await axios.post(
    `${PATIENT_DEACTIVATION.base}/process/${dni}`,
    body,
    { headers }
  );
  return data;
};

// Lista de motivos válidos para el campo `reason` del paso process
export const GetUnsubscribeReasons = async () => {
  const { data } = await axios.get(UNSUBSCRIBE_REASONS.base, { headers });
  return data;
};
